<div
  class="is-flex is-fullheight is-justify-content-space-between is-flex-direction-column"
>
  <div class="notification is-primary is-light">
    <h5 class="title" translate>kwh.actions.archiving.info.title</h5>
    <p translate>kwh.actions.archiving.info.text</p>

    <ul>
      <li>
        <fino-icon
          class="icon has-icon-success mt-1"
          icon="Check"
          type="bold"
        ></fino-icon>
        <span class="ml-2" translate>kwh.actions.archiving.info.archived</span>
      </li>
      <li>
        <fino-icon
          class="icon has-icon-danger mt-1"
          icon="Remove Bold"
          type="bold"
        ></fino-icon>
        <span class="ml-2" translate>
          kwh.actions.archiving.info.not-archived
        </span>
      </li>
      <li>
        <fino-icon
          class="icon mt-1"
          icon="Road Sign No Entry"
          type="bold"
        ></fino-icon>
        <span class="ml-2" translate>
          kwh.actions.archiving.info.archiving-not-possible
        </span>
      </li>
    </ul>
  </div>

  <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
    <thead>
      <tr>
        <th translate>kwh.actions.archiving.table.doc-type</th>
        <th class="has-text-centered" translate>
          kwh.actions.archiving.table.incoming
        </th>
        <th class="has-text-centered" translate>
          kwh.actions.archiving.table.outgoing
        </th>
      </tr>
    </thead>
    <tbody>
      @for (docType of archivingDocTypes | keyvalue; track docType.value) {
        <tr>
          <td
            [translate]="'kwh.actions.archiving.docTypes.' + docType.value"
          ></td>
          <td class="has-text-centered">
            <fino-icon
              class="icon"
              [icon]="getIconForArchiving('NEW_BANK', docType.value)"
              type="bold"
              [ngClass]="getIconClassForArchiving('NEW_BANK', docType.value)"
            ></fino-icon>
          </td>
          <td class="has-text-centered">
            <fino-icon
              class="icon"
              [icon]="getIconForArchiving('OLD_BANK', docType.value)"
              type="bold"
              [ngClass]="getIconClassForArchiving('OLD_BANK', docType.value)"
            ></fino-icon>
          </td>
        </tr>
      }
    </tbody>
  </table>

  <div class="is-flex is-centered">
    <button
      type="button"
      (click)="downloadReport()"
      fino-button
      class="mr-1"
      [loading]="reportDownloading"
    >
      <fino-icon icon="File Csv" class="icon"></fino-icon>
      <label translate="kwh.actions.archiving.download"></label>
    </button>
    <button
      [primary]="true"
      type="button"
      (click)="openModal()"
      class="ml-1"
      fino-button
      [label]="ctaLabel()"
    ></button>
  </div>
</div>
